import { ShieldAlert } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAccessReasonStore } from '@/stores/accessReasonStore'

/** Slim, persistent notice while the super admin's stated access reason is active. */
export function SupportAccessBanner() {
  const reason = useAccessReasonStore(s => s.reason)
  const openChangePrompt = useAccessReasonStore(s => s.openChangePrompt)
  const clearReason = useAccessReasonStore(s => s.clearReason)

  if (!reason) return null

  return (
    <section
      aria-label='Super admin access'
      className='flex flex-wrap items-center gap-x-4 gap-y-2 border-amber-500/30 border-b bg-amber-500/10 px-4 py-2 text-amber-950 sm:px-6 lg:px-8 dark:text-amber-100'
    >
      <ShieldAlert className='h-4 w-4 shrink-0' aria-hidden />
      <p className='min-w-0 flex-1 text-sm'>
        <span className='font-semibold'>Super admin access:</span>{' '}
        <span className='break-words'>{reason}</span>
      </p>
      <div className='flex shrink-0 items-center gap-2'>
        <Button
          size='sm'
          variant='outline'
          className='h-8 bg-background'
          onClick={openChangePrompt}
        >
          Change
        </Button>
        <Button size='sm' variant='ghost' className='h-8' onClick={clearReason}>
          End
        </Button>
      </div>
    </section>
  )
}
